import {
  IOpportunityDetails,
  OpportunityStatus,
  OpportunityStatusName
} from '@store/Opportunity/types'

export const getOpportunityStatusName = (status: OpportunityStatus) => {
  switch (status) {
    case OpportunityStatus.DEFAULT:
      return OpportunityStatusName.DEFAULT
    case OpportunityStatus.APPROVED:
      return OpportunityStatusName.APPROVED
    case OpportunityStatus.REJECTED:
      return OpportunityStatusName.REJECTED
    default:
      return ''
  }
}

export const shouldRenderOpportunityDetail = (key: string): boolean => {
  switch (key) {
    case 'status_name':
      return false
    case 'related_dos_array':
      return false
    case 'opportunity_status':
      return false
    case 'client':
      return false
    case 'attributed_member_year_savings':
      return false
    case 'attributed_sponsor_year_savings':
      return false
    default:
      return true
  }
}

export const getOpportunityDetailTitle = (key: string) => {
  switch (key) {
    case 'id':
      return 'ID'
    case 'status':
      return 'Status'
    case 'generated_id':
      return 'Generated ID'
    case 'opportunity_type':
      return 'Opportunity Type'
    case 'rule_name':
      return 'Rule Name'
    case 'opportunity_status':
      return 'Opportunity Status'
    case 'latest_dos':
      return 'Latest DOS'
    case 'related_dos_array':
      return 'Related DOS Array'
    case 'adherence_ratio':
      return 'Adherence Ratio'
    case 'attributed_member_year_savings':
      return 'Attributed Member Year Savings'
    case 'attributed_sponsor_year_savings':
      return 'Attributed Sponsor Year Savings'
    case 'current_awp':
      return 'Current AWP'
    case 'current_drug_name':
      return 'Current Drug Name'
    case 'current_drug_strength':
      return 'Current Drug Strength'
    case 'current_ndc':
      return 'Current NDC'
    case 'expected_refill_date':
      return 'Expected Refill Date'
    case 'year_savings':
      return 'Year Savings'
    case 'category':
      return 'Category'
    case 'client':
      return 'Client'
    case 'note':
      return 'Note'
    case 'Recommendation':
      return 'Recommendation'
    case 'target_gpi_1':
      return 'Target GPI'
    case 'target_ndc_1':
      return 'Target NDC'
    default:
      return key.replaceAll('_', ' ').toUpperCase()
  }
}

export const getOpportunityDetailValue = (
  key: string,
  value: IOpportunityDetails[keyof IOpportunityDetails]
) => {
  switch (key) {
    case 'status':
      return getOpportunityStatusName(value as OpportunityStatus)
    case 'latest_dos':
    case 'expected_refill_date':
      return new Date(value as string).toLocaleDateString('en-US', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    case 'related_dos_array':
      if (!Array.isArray(value) || value.length === 0) {
        return 'N/A'
      }
      return (
        ((value as string[]) ?? [])
          .map((date: string) =>
            new Date(date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: '2-digit',
              day: '2-digit'
            })
          )
          ?.join(', ') || 'N/A'
      )
    case 'target_ndc_1':
      if (!Array.isArray(value) || value.length === 0) {
        return 'N/A'
      }
      return value as string[]
    default:
      return value || 'N/A'
  }
}
